import { Fragment, useState } from "react";
import { Stack } from "@mui/material";
import { CircularProgress } from '@mui/material';
import { TableBasic } from "../../components/TableBasic";
import { TitlePage } from "../../components/TitlePage";
import useFetch from "../../hooks/useFetch";
import { useEffect } from "react";
import { actualDateFormmater, urlWorks } from "../../helpers";
import { FilterWork } from "./components/FilterWork";
import { dateFormmater } from "../../helpers";
import { diffDates } from "../../helpers/productsPrice";

export const WorkScreen = ({ status, isItCertified }) => {

    const [filterArray, setFilterArray] = useState([]);
    const [copyArray, setCopyArray] = useState([]);
    const [dataOk, setDataOk] = useState([]);
    const { data } = useFetch(urlWorks, 'GET', {});
    const dataWork = data?.works;

    useEffect(() => {
        setDataOk(dataWork?.map((o => ({
            'id': o.id,
            'addressWork': o.addressWork,
            'contact': o.contact,
            'clientTel': JSON.parse(o.client.contacts)[0].contactTel,
            'firstDate': o.firstDate ? dateFormmater(o.firstDate) : 'No disponible',
            'status': o.status
        }))))
    }, [dataWork])

    useEffect(() => {
        if (status) {
            setFilterArray(dataOk?.filter(el => el.status === status));
            setCopyArray(dataOk?.filter(el => el.status === status))
        } else if (isItCertified) {
            let idWithCertification = [];
            data?.certification.forEach((el) => {
                const fecha = actualDateFormmater(new Date().toLocaleDateString())
                if ((diffDates(el.firstDate, fecha) >= 1) && (diffDates(fecha, el.lastDate) > 0)) {
                    idWithCertification.push(el.work.id)
                }
            })

            const worksWithoutCertifications = dataOk?.filter((el) =>
            !idWithCertification.includes(el.id) && (el.status === 'Montada'))

            setFilterArray(worksWithoutCertifications)
            setCopyArray(worksWithoutCertifications)

        } else {
            setFilterArray(dataOk)
            setCopyArray(dataOk)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status, dataOk, isItCertified])

    return (
        <Stack width='100%' alignItems='center' mt='2rem'>
            <Stack width='95%' alignItems='center'>
                <TitlePage title={title} subtitle={subtitle} />
                {
                    (dataOk && filterArray)
                        ? <Fragment>
                            <FilterWork setFilterArray={setFilterArray} copyArray={copyArray} />
                            <TableBasic setCopyArray={setCopyArray} tableTitle={tableTitle} rows={filterArray} colNames={colNames} values={values} setFilterArray={setFilterArray} />
                        </Fragment>
                        : <CircularProgress />
                }
            </Stack>
        </Stack>
    )
}

const title = 'Obras';
const subtitle = 'Consulte todas las obras'
const tableTitle = 'work';

const colNames = ['Dirección de obra', 'Contacto', 'Teléfono', 'Fecha estimada inicio', 'Estado', ''];

const values = ['id', 'addressWork', 'contact', 'clientTel', 'firstDate', 'status'];